import React, { Component, useEffect, useState } from "react";
import store from "@/redux/store";
import {addDocument, showConfirmModal, hideModal} from "@/reducers/ModalPopup";
import {removeDocument} from "@/reducers/Document";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { useModel } from "@/models/base/useModel";
import { FieldHolder } from "@/components/holders/FieldHolder";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { addCompany, addCustomer, loadCustomer, loadCustomers, unsetSelected } from "@/reducers/Customer";

interface ComponentProps {
  [key: string]: any; //Accept any property
};
function CompanyDetail({...props}: ComponentProps): any{

    const [returnToPrevPage, setReturnToPrevPage] = useState(false);
    const navigate = useNavigate();
    const {id} = useParams<string>();
    const dispatch = useDispatch<any>();
    const [cdata, setData] = useState();
    type RootState = ReturnType<typeof store.getState>
    
    const { customerModel, error, redirect } = useSelector((state: RootState) => {
        return {
          customerModel: (state.CustomerReducer.selected === null) ? state.CustomerReducer.customerModel : state.CustomerReducer.selected,
          error: state.CustomerReducer.error,
          redirect: state.CustomerReducer.redirect,

          
        };
      },shallowEqual);
    const {tm, registerField} = useModel('name', customerModel);
    const { t, i18n, ready } = useTranslation();

    const storeEventHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();

        store.dispatch( addCompany(customerModel.getChanges())).then((event) => {
          if(event?.payload?.status == undefined || event?.payload?.status < 400) {
            setReturnToPrevPage(true);
          }
        })


        return false;
    };

  useEffect(() => {
    if (returnToPrevPage) {
      navigate('/customers');
    }
  }, [returnToPrevPage]);


// const user1 = useSelector((state) => console.debug(state));
//const user = useStore((store) => store.Customer.customerModel);
    // const mapStateToProps = (state) => ({ customerData: state.Customer.customerModel });
    //    const data = useSelector((state) => state);
    // const {companyData} = useSelector((state) => ({
    //     companyData: state.CustomerReducer.customerModel
    // }));
    

    const prefixTranslationId = "views.company.company.label.";
    const getTransLation =(id) => {
        return t(prefixTranslationId+id);
    }
    return (
<>
              <div className="mb-6 rounded-2xl max-w-2xl border border-gray-200 p-5 lg:p-6 dark:border-gray-800">
                <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
                  <div>
      <fieldset>
        <legend className="block text-sm/6 font-medium text-gray-900 dark:text-white">Algemene bedrijfsgegevens</legend>
        <div className="mt-2 grid grid-cols-12">
                <FieldHolder colspan="12" smcolspan="12" label-hide={getTransLation("companyName")} id="name" error={error} className="border-b-none" 
                innerClass="border border-b-none block w-full rounded-t-md bg-white  text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500">
                    <input {...registerField('name')}
                    placeholder="Bedrijfsnaam"
                    className="border-none block w-full rounded-t-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"/>
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="12"  id="address" error={props?.state?.error}>
                    <input {...registerField('addresses.0.address', 'input')}
                    placeholder="Vestigingsadres + nr."
              className="border block w-full rounded-bl-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500" />
                </FieldHolder>

                <FieldHolder colspan="12" smcolspan="4"  id="address" error={props?.state?.error} className="-mt-px -mr-px">
                    <input {...registerField('addresses.0.zipcode', 'input')}
                    placeholder="Postcode"
              className="border block w-full rounded-bl-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                    />
                </FieldHolder>

                <FieldHolder colspan="12" smcolspan="8"  id="residence" error={props?.state?.error} className="-mt-px">
                    <input {...registerField('addresses.0.residence', 'input')}
                    placeholder="Vestigingsplaats"
              className="border block w-full rounded-br-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                    />
                </FieldHolder>
        </div>
      </fieldset>

      <fieldset className="mt-4">
        <legend className="block text-sm/6 font-medium text-gray-900 dark:text-white">Contactgegevens</legend>
        <div className="mt-2 grid grid-cols-12">
                <FieldHolder colspan="12" smcolspan="6" label-hide={getTransLation("companyName")} id="phone" error={props?.state?.error} className="border-b-none">
                    <input {...registerField('contact.0.phone')}
                    placeholder="Telefoon nr."
              className="border-l border-t block w-full rounded-ll-md rounded-b-none bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                    />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="6"  id="mobile" error={props?.state?.error}>
                    <input {...registerField('contact.0.mobile', 'input')}
                    placeholder="Mobiel nr."
              className="border-x border-t block w-full rounded-tr-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
              />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="6"  id="fax" error={props?.state?.error}>
                    <input {...registerField('contact.0.fax', 'input')}
                    placeholder="Fax nr."
              className="border block w-full rounded-bl-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                    />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="6"  id="email" error={props?.state?.error}>
                    <input {...registerField('contact.0.other1', 'input')}
                    placeholder="Email adres"
              className="border-y border-r block w-full bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
              />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="12"  id="website adres" error={props?.state?.error}>
                    <input {...registerField('contact.0.other2', 'input')}
                    placeholder="Website adres"
              className="border-b border-x block w-full rounded-bx-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
              />
                </FieldHolder>

        </div>
      </fieldset>

      <fieldset className="mt-4">
        <legend className="block text-sm/6 font-medium text-gray-900 dark:text-white">BTW & KvK gegevens</legend>
        <div className="mt-2 grid grid-cols-12">
                <FieldHolder colspan="12" smcolspan="12" label-hide={getTransLation("companyName")} id="vatid" error={props?.state?.error} className="border-b-none">
                    <input {...registerField('vatid')}
                    placeholder="BTW nummer"
              className="border-l border-t block w-full rounded-ll-md rounded-b-none bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                    />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="12"  id="coc" error={props?.state?.error}>
                    <input {...registerField('coc', 'input')}
                    placeholder="KvK nummer"
              className="border-x border-t block w-full rounded-tr-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
              />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="6"  id="sbi_code" error={props?.state?.error}>
                    <input {...registerField('sbi_code', 'input')}
                    placeholder="SBI code"
              className="border-y border-r block w-full bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
              />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="6"  id="startdate" error={props?.state?.error}>
                    <input {...registerField('startdate', 'input')}
                    placeholder="Start datum"
              className="border block w-full rounded-bl-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                    />
                </FieldHolder>
                <FieldHolder colspan="12" smcolspan="12"  id="sbi_description" error={props?.state?.error}>
                    <input {...registerField('sbi_description', 'input')}
                    placeholder="SBI Omschrijving"
              className="border-b border-x block w-full rounded-bx-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-gray-700 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
              />
                </FieldHolder>

        </div>
      </fieldset>


          <div className="flex items-center justify-end gap-x-2 border-t border-gray-900/10 py-2 pl-4  m-0 pr-0">
            <Link to={"../"} type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              onClick={(event) => storeEventHandler(event)}
              className="rounded-md bg-indigo-600 px-2 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>


  </div></div></div>

  
        </>
    )

}


 export {CompanyDetail}